import React, { useMemo, useState } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaCalendar, FaMoneyBill, FaLine } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem, ModalComponent } from '../_components'
import { IdleTimeout } from '../_screens'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Chart as ChartJS } from 'chart.js/auto'

const steps = [
  "Pending", "Actioned"
]

const ProgressField = record => {
  return (
    <div className="flex w-full items-center justify-center">
      <ProgressBar value={record.value}/>
      <div className="text-xs mx-2">
          {`${record.value}%`}
      </div>
    </div>
  )
}

const MenuItemLink = ( { label, icon, spaced, slug, updateItcoApplicationsStatus = "" } ) => {

  const handleNavigate = async () => {
    console.log("clicked status "+slug)
    updateItcoApplicationsStatus(slug)
  }
  return (
      <button type="button" onClick={handleNavigate} className={`flex h-full border-gray-200 hover:bg-green-900 hover:rounded-md hover:font-bold hover:text-black ${ spaced } `}>
          <div className="h-full w-full flex items-center justify-center">
              <span>{icon}</span>
              <span className="text-lime-400 text-xs md:text-xs lg:text-xs">{label}</span>
          </div>
      </button>
  )
}

export default function Dashboard( { product } ) {

  const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "display" )
        await localStorage.setItem( "applicationId", record?.value )
        fetchParticularApplication()
        setCreatetask(true)
        //return window.location.reload()
        } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {tag === "Pending" ? `Action` : `View`}
      </div>
    )
  }

  const DeleteView = record => {
    // console.log("record ===> "+record.row.original.stage)
    return (
      <>
        {(record.row.original.stage <= 3 || record.row.original.stage === null) &&
        <div className="flex items-center">
          <div onClick={ async() => {
            if (window.confirm("Are you sure you want to delete this application ?") == true) {
              try {
                const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/delete_application`, {
                  application_id: record.row.original.id,
                  deleted_by: localStorage.getItem( "email" )
                })
                if( response.data ) {
                  alert( response.data.message )
                  return window.location.reload()
                }
              } catch (error) {
                console.log( error )
              }
            }
    
          } } className="rounded bg-red-500 border border-gray-200 px-2 py-1 text-center text-white cursor-pointer">
            {`Delete`}
          </div>
        </div>
        }
      </>
    )
  }

  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Business Trading Name",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Annual Income",
      accessor: "annual_income"
    },
    {
      Header: "Application Progress",
      accessor: "progress",
      Cell: ProgressField
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    },
    {
      Header: "Delete",
      accessor: "edit",
      Cell: DeleteView
    }
  ] )


  const UserActivityColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "User",
      accessor: "email_address"
    },
    {
      Header: "Comment",
      accessor: "comments"
    }
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ remarks, setRemarks ] = useState( [] )
  const [ registrationCount, setRegistrationCount ] = useState( 0 )
  const [ allApplicationsCount, setAllApplicationsCount ] = useState( 0 )
  const [ approvedCount, setApprovedCount ] = useState( 0 )
  const [ scheduledAuditsCount, setScheduledAuditsCount ] = useState( 0 )
  const [ pendingCount, setPendingCount ] = useState( 0 )
  const [ newAppsCount, setNewAppsCount ] = useState( 0 )
  const [ auditReportsCount, setAuditReportsCount ] = useState( 0 )
  const [ renewalsCount, setRenewalsCount ] = useState( 0 )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )
  const [itcoApplicationsLevel, setItcoApplicationsLevel] = useState('0'); 
  const [ levelRecords, setLevelRecords ] = useState( [] )
  const [createtask, setCreatetask] = useState( false );
  const [ selectedRecord, setSelectedRecord ] = useState( null )

  React.useEffect( () => {
    if( loading ) {
      fetchApplications()
      fetchRemarks()
      fetchUserRegistrationsCount()
      fetchRenewalsCount()
      fetchAuditReportsCount()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        const results = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            progress: result.progress,
            security_clearance_form: result.security_clearance_form,
            stage: result.stage,
            applicant: result.trading_name,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
          }
        })

        const approvedApplications = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by, 
            status: result.status, 
            id: result.id
          }
        }).filter( record => record?.stage === "9" )

        const pendingApplications = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by, 
            status: result.status, 
            id: result.id
          }
        }).filter( record => record?.stage === "8" )

        const newApplications = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by, 
            status: result.status, 
            id: result.id
          }
        }).filter( record => record?.stage === "1" )

        const scheduledAudits = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by, 
            status: result.status,
            scheduled_action: result.scheduled_action, 
            id: result.id
          }
        }).filter( record => record?.scheduled_action === "DATE_CONFIRMED" )

        //update the state
        setRecords( results )
        setAllApplicationsCount( response.data.length)
        setApprovedCount( approvedApplications.length)
        setLoading( false )
        setPendingCount(pendingApplications.length)
        setNewAppsCount(newApplications.length)
        setScheduledAuditsCount(scheduledAudits.length)
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const fetchParticularApplication = async () => {
    try {
     const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )
     if( response.data ) {
      setSelectedRecord( response.data.record )
     }
    } catch (error) {
      console.log("failed to fetch particular application details")
    }
  }

  const fetchRemarks = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getAllITRemarks` ) 
      if( response.data ) {
       const remarkresults = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            email_address: result.actioned_by,
            comments: result.comments
        }
       } ).filter(record => { 
        return record.comments !== null
      })

       //update the state
       setRemarks( remarkresults )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const fetchPayments = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        var fees_to_pay_sum = 0;
        const results = response.data.map( ( result, index ) => {
          fees_to_pay_sum += (result.certification_fees_to_pay != null) ? parseInt(result.certification_fees_to_pay) : 0
          return {
            recordId: `${index+1}`,
            sno: result.serial_number,
            progress: result.progress,
            applicant: result.trading_name,
            entity_name: result.entity_name, 
            date_updated: moment( result.updated_at ).format( "DD MMM, YYYY" ),
            contact_person: `${result.contact_first_name || ""} ${result.contact_last_name || ""}`,
            designation: result.designation,
            email_id: result.created_by,
            phone_number: result.contact_phone_number,
            verify_status: result.verification_status || "Pending",
            updated_at: result.updated_at,
            id: result.id,
            report: "",
            stage: result.stage,
            prn: result.payment_reference_number,
            prn_status: result.prn_status,
            certification_fees_to_pay: result.certification_fees_to_pay
          }
        }).sort( ( a, b ) => {
          return moment( b.updated_at ).format( "YYYYMMDDHHMM" ) - moment( a.updated_at ).format( "YYYYMMDDHHMM" )
        })
        setLoading( false )
      }
    } catch (error) {
      console.log("failed to fetch applications for finance")
      alert( "Server error occurred." )
      setLoading( false )
    }
  }

  const fetchLevelApplications = async (itcoApplicationsLevel) => {
    try {
      console.log("fetching based on level ==> " +itcoApplicationsLevel)
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/`+itcoApplicationsLevel+`/level` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            applicant: result.trading_name,
            stage: result.stage,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } )

       //update the state
       setLevelRecords( results )
       //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      //setLoading( false )
    }
  }

  const fetchStatusApplications = async (slug) => {
    try {
      //console.log("fetching based on status ==> " +slug)
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/`+slug+`/status` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            applicant: result.trading_name,
            stage: result.stage,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } )

       //update the state
       setLevelRecords( results )
       //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      //setLoading( false )
    }
  }

  const fetchUserRegistrationsCount = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getUserRegistrationsCount` ) 
      if( response.data ) {
       const usercount = response.data.usercount

       setRegistrationCount( usercount )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const fetchRenewalsCount = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getRenewalsCount` ) 
      if( response.data ) {
       const renewalscount = response.data.renewalscount

       setRenewalsCount( renewalscount )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const fetchAuditReportsCount = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/get_audit_reports_count` ) 
      if( response.data ) {
       const audit_reports_count = response.data.audit_reports_count

       setAuditReportsCount( audit_reports_count )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const listApprovedApplications = async() => {
    await localStorage.setItem( "link", "approved_list" )
    return window.location.reload()
  }

  const listPendingEDApprovals = async() => {
    await localStorage.setItem( "link", "pending_list" )
    return window.location.reload()
  }

  const listUserRegistrations = async () => {
    await localStorage.setItem( "link", "all_applicants" )
    return window.location.reload()
  }

  const handleResults = ( values ) => {
    // Ensure values is always an array
    if (!values || !Array.isArray(values)) {
      return [];
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("VERIFIER")){
      return values.filter( item => {
        if( tag?.toLowerCase() === "pending" ) {
          return parseInt( item.stage ) === 1
        }
        if( tag?.toLowerCase() === "actioned" ) {
          return parseInt( item.stage ) > 1
        }
        return false; // Add default return for filter
      })
    }
    
    if(localStorage.getItem( "role" )?.toUpperCase().includes("FINANCE")){
      return values.filter( item => parseInt( item.stage ) === 2  )
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("VERIFIER") || localStorage.getItem( "role" )?.toUpperCase().includes("AUDITOR")){
      return values.filter( item => (parseInt( item.stage ) === 3 || parseInt( item.stage ) === 4 ))
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("AUDITOR")){
      return values.filter( item => (parseInt( item.stage ) === 3 || parseInt( item.stage ) === 4 ))
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("SECURITY")){
      return values.filter( item => (parseInt( item.stage ) === 5 && item.security_clearance_form === 0)  )
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("QA1")){
      return values.filter( item => (parseInt( item.stage ) === 5 && item.security_clearance_form !== 0)  )
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("QA2")){
      return values.filter( item => parseInt( item.stage ) === 6  )
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("QA3")){
      return values.filter( item => {
        if( tag?.toLowerCase() === "pending" ) {
          return (parseInt( item.stage ) === 7 )
        }
        if( tag?.toLowerCase() === "actioned" ) {
          return parseInt( item.stage ) === 8
        }
        return false; // Add default return for filter
      })
    }

    if(localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER")){
      return values.filter( item => {
        if( tag?.toLowerCase() === "pending" ) {
          return (parseInt( item.stage ) === 8 )
        }
        if( tag?.toLowerCase() === "actioned" ) {
          return parseInt( item.stage ) == 9
        }
        return false; // Add default return for filter
      })
    }

    // Default return - this is crucial to prevent undefined
    return values || [];
  }

  const updateItcoApplicationsLevel = (data) => {
    setItcoApplicationsLevel(data);
    fetchLevelApplications(itcoApplicationsLevel)
  };

  const updateItcoApplicationsStatus = (data) => {
    setItcoApplicationsLevel(data);
    fetchStatusApplications(itcoApplicationsLevel)
  };

  const handleIdle = () => {
    localStorage.clear();
    // Perform any other actions you need when the application is idle.
    return window.location.reload()
  };

  return (
    <Wrapper>
      <div className="flex flex-col h-full">
        <BarStrip title="Dashboard" updateItcoApplicationsLevel={updateItcoApplicationsLevel} />
        <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
          {`Cumulative overview`}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 my-4">
            <div className="flex items-center justify-between cursor-pointer bg-white px-3 py-3 md:py-5 rounded-md border-2 border-sky-600 min-h-[120px]" onClick={async () => {
                await localStorage.setItem( "link", "certificate_progress" )
                return window.location.reload()
                }}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="all" label="" spaced icon={<FaBook size={40} color={`#5aab5a`}/>} updateItcoApplicationsStatus={updateItcoApplicationsStatus}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{allApplicationsCount}</h3>
                <div className="text-xs md:text-base">{`All applications`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-green-500 cursor-pointer min-h-[120px]" onClick={listApprovedApplications}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="approved" label="" spaced icon={<FaThumbsUp size={40} color={`#5aab5a`}/>} updateItcoApplicationsStatus={updateItcoApplicationsStatus}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{approvedCount}</h3>
                <div className="text-xs md:text-base">{`Approved`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-orange-400 cursor-pointer min-h-[120px]" onClick={listPendingEDApprovals}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="rejected" label="" spaced icon={<FaThumbsDown size={40} color={`#5aab5a`}/>} updateItcoApplicationsStatus={updateItcoApplicationsStatus}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{pendingCount}</h3>
                <div className="text-xs md:text-base">{`Pending`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-amber-300 min-h-[120px]">
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="renewed" label="" spaced icon={<FaRegIdCard size={40} color={`#5aab5a`}/>}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{renewalsCount}</h3>
                <div className="text-xs md:text-base">{`Renewals`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-violet-300 cursor-pointer min-h-[120px]" onClick={listUserRegistrations}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="renewed" label="" spaced icon={<FaRegIdCard size={40} color={`#5aab5a`}/>}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{registrationCount}</h3>
                <div className="text-xs md:text-base">{`Registrations`}</div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 my-4">
            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-cyan-400 cursor-pointer min-h-[120px]" onClick={async () => {
                await localStorage.setItem( "link", "certificate_progress" )
                return window.location.reload()
                }}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="renewed" label="" spaced icon={<FaLine size={40} color={`#5aab5a`}/>}/>
              </div>
              <div className="px-2 md:px-3 py-1 cursor-pointer">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{newAppsCount}</h3>
                <div className="text-xs md:text-base">{`New Applications`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-sky-600 min-h-[120px]">
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="all" label="" spaced icon={<FaCalendar size={40} color={`#5aab5a`}/>}/>
              </div>
              <div className="px-2 md:px-3 py-1">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{scheduledAuditsCount}</h3>
                <div className="text-xs md:text-base">{`Scheduled Audits`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-lime-800 cursor-pointer min-h-[120px]" onClick={async () => {
                await localStorage.setItem( "link", "paid_but_not_signed" )
                return window.location.reload()
                }}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="approved" label="" spaced icon={<FaMoneyBill size={40} color={`#5aab5a`}/>}/>
              </div>
              <div className="px-2 md:px-3 py-1 cursor-pointer">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{approvedCount}</h3>
                <div className="text-xs md:text-base">{`Audit Payments`}</div>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white px-3 py-3 md:py-5 rounded-md border-2 border-rose-400 cursor-pointer min-h-[120px]" onClick={async () => {
                await localStorage.setItem( "link", "all_audit_reports" )
                return window.location.reload()
                }}>
              <div className="bg-lime-200 rounded-full my-2 shrink-0">
                <MenuItemLink slug="rejected" label="" spaced icon={<FaBook size={40} color={`#5aab5a`}/>} />
              </div>
              <div className="px-2 md:px-3 py-1 cursor-pointer">
                <h3 className="text-2xl md:text-4xl font-bold leading-none">{auditReportsCount}</h3>
                <div className="text-xs md:text-base">{`Audit Reports`}</div>
              </div>
            </div>
          </div>

          <div className="flex">
            <div className="flex-auto w-64 text-gray-400">
              <div className="px-5 py-2 text-lg bg-white rounded-lg">
                {`All Application Summary`}
              </div>
              <div className="flex flex-col justify-center w-full bg-white px-5 rounded-lg">
                <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                  {/* tabs */}
                  {steps.map( ( item, index ) => {
                    return (
                    <StepperItem 
                      edge={index === 0} 
                      active={tag.toUpperCase() === item?.toUpperCase()} 
                      key={item} 
                      label={item} 
                      onPress={() => {
                        return setTag( item )
                      } } />
                    )
                  } )}
                </div>
                <Table 
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="Application Details"
                  columns={ApplicationColumns}
                  data={itcoApplicationsLevel === "0" ? handleResults(records) : handleResults(levelRecords)}
                  hidePagination={false}
                  exportToExcel={() => {}}
                  exportToCSV={() => {}}
                />
              </div>
            </div>


            {/* <div className="flex-auto w-32 text-gray-400">
              <div className="px-5 pt-2 ml-5 text-lg bg-white rounded-lg">
                {`Tasks By User`}
              </div>
              <div className="px-5 ml-5 flex flex-col justify-center bg-white rounded-lg">
                <Table 
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="User Activity"
                  columns={UserActivityColumns}
                  data={remarks}
                  hidePagination={false}
                  exportToExcel={() => {}}
                  exportToCSV={() => {}}
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      
      <IdleTimeout timeout={1200000} onIdle={handleIdle} />

      <ModalComponent title={`Action`} open={createtask}>
        <div className="flex flex-col items-center justify-center">
          {localStorage.getItem( "role" )?.toUpperCase().includes("VERIFIER") &&
            (selectedRecord?.verification_status !== "COMPLETED" && <button onClick={async () => {
              await localStorage.setItem( "application_action", "VERIFIER" )
              return window.location.reload()
              } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#369fc8] text-xs text-white flex items-center justify-center">
              Verify Documents
            </button>)
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("AUDITOR") &&
            (<button onClick={async () => {
              await localStorage.setItem( "application_action", "AUDITOR" )
              return window.location.reload()
              } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#866ec9] text-xs text-white flex items-center justify-center">
              Audit
            </button>)
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("SECURITY") &&
            (<button onClick={async () => {
              await localStorage.setItem( "application_action", "SECURITY" )
              return window.location.reload()
              } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#866ec9] text-xs text-white flex items-center justify-center">
              Security Clearance Form
            </button>)
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("QA1") &&
            (
              <>
                <button onClick={async () => {
                  await localStorage.setItem( "application_action", "QA1" )
                  return window.location.reload()
                  } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#cead1a] text-xs text-white flex items-center justify-center">
                  Quality Assurance 1
                </button>
                {selectedRecord?.assigned_auditor === null && 
                  <button onClick={async () => {
                    await localStorage.setItem( "application_action", "ASSIGN_AUDITOR" )
                    return window.location.reload()
                    } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#1a9bce] text-xs text-white flex items-center justify-center">
                    Assign Auditor
                  </button>
                }
              </>
            )
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("QA2") &&
            (<button onClick={async () => {
            await localStorage.setItem( "application_action", "QA2" )
            return window.location.reload()
            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#cead1a] text-xs text-white flex items-center justify-center">
            Quality Assurance 2
          </button>)
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("QA3") &&
            (<button onClick={async () => {
            await localStorage.setItem( "application_action", "QA3" )
            return window.location.reload()
            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#cead1a] text-xs text-white flex items-center justify-center">
            Quality Assurance 3
          </button>)
          }

          {localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER") &&
            (<button onClick={async () => {
            await localStorage.setItem( "application_action", "APPROVER" )
            return window.location.reload()
            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 px-2 rounded bg-[#cead1a] text-xs text-white flex items-center justify-center">
            {tag === "Pending" ? `Approve` : `View Details`}
          </button>)
          }
          
          <button onClick={async () => {
            setCreatetask(false)
            } } className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#54554d] text-xs text-white flex items-center justify-center">
            Close
          </button>
        </div>
      </ModalComponent>
    </Wrapper>
  )
}
